const navigation = [
  { name: 'About', href: '#about' },
  { name: 'Experience', href: '#experience' },
  { name: 'Projects', href: '#projects' },
  { name: 'Skills', href: '#skills' },
  { name: 'Contact', href: '#contact' },
];

const CV_PATH = '/Harsh-Trivedi-CV.pdf';

export default function Header() {
  return (
    <>
      <header className="govuk-header" data-module="govuk-header">
        <div className="govuk-header__container govuk-width-container">
          <div className="govuk-header__logo">
            <a href="#main-content" className="govuk-header__homepage-link">
              <span className="app-header-badge" aria-hidden="true">HT</span>
              <span className="govuk-header__product-name">Harsh Trivedi</span>
            </a>
          </div>
        </div>
      </header>

      <section
        aria-label="Service information"
        className="govuk-service-navigation"
        data-module="govuk-service-navigation"
      >
        <div className="govuk-width-container">
          <div className="govuk-service-navigation__container">
            <span className="govuk-service-navigation__service-name">
              <span className="govuk-service-navigation__text">
                Public sector digital transformation
              </span>
            </span>

            <nav aria-label="Menu" className="govuk-service-navigation__wrapper">
              <button
                type="button"
                className="govuk-service-navigation__toggle govuk-js-service-navigation-toggle"
                aria-controls="navigation"
                hidden
                aria-hidden="true"
              >
                Menu
              </button>
              <ul className="govuk-service-navigation__list" id="navigation">
                {navigation.map((item) => (
                  <li key={item.name} className="govuk-service-navigation__item">
                    <a className="govuk-service-navigation__link" href={item.href}>
                      {item.name}
                    </a>
                  </li>
                ))}
                <li className="govuk-service-navigation__item">
                  <a className="govuk-service-navigation__link" href={CV_PATH} download>
                    Download CV
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
}
